import axios from 'axios';

const API_ENDPOINT = `${import.meta.env.VITE_API_URL}/book-call`;

/**
 * Get available dates for booking
 * @returns {Promise} Promise with available dates
 */
export const getAvailableDates = async () => {
    try {
        const response = await axios.get(`${API_ENDPOINT}/available-dates`);
        return response.data;
    } catch (error) {
        console.error('Error fetching available dates:', error);
        throw error;
    }
};

/**
 * Get available time slots for a specific date
 * @param {string} date - Date in ISO format (YYYY-MM-DD)
 * @param {string} timezone - User's timezone (e.g., 'Asia/Kolkata')
 * @returns {Promise} Promise with available time slots
 */
export const getAvailableTimeSlots = async (date, timezone) => {
    try {
        const response = await axios.get(`${API_ENDPOINT}/available-time-slots`, {
            params: { date, timezone }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching available time slots:', error);
        throw error;
    }
};

/**
 * Book a demo call
 * @param {Object} bookingData - Booking details
 * @param {string} bookingData.name - User's name
 * @param {string} bookingData.email - User's email
 * @param {string} bookingData.phone - User's phone number (optional)
 * @param {string} bookingData.date - Selected date (YYYY-MM-DD)
 * @param {string} bookingData.time - Selected time (HH:MM)
 * @param {string} bookingData.timezone - User's timezone
 * @param {string} bookingData.additionalInfo - Additional information (optional)
 * @returns {Promise} Promise with booking confirmation
 */
export const bookDemoCall = async (bookingData) => {
    try {
        const response = await axios.post(`${API_ENDPOINT}/book`, bookingData);
        return response.data;
    } catch (error) {
        console.error('Error booking demo call:', error);
        throw error;
    }
};

export default {
    getAvailableDates,
    getAvailableTimeSlots,
    bookDemoCall
}; 